<template>
  <v-text-field
      :label="label"
      :rules="stringRules"
      :solo="solo"
      :tabindex="tabindex"
      :suffix="suffix"
      :value="numberStr"
      @input="setNumber($event)"
      @blur="handleBlur(); $emit('blur', $event)"
      @focus="handleFocus()"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      v-on:update:error="$emit('update:error', $event)"
      inputmode="numeric"
      :disabled="disabled"
      :readonly="readonly"
      :outlined="outlined"
      :dense="dense"
      ref="input"
  ></v-text-field>
</template>

<script>
  export default {
    name: 'FhNumber',
    props: [
      'label',
      'rules',
      'solo',
      'tabindex',
      'type',
      'value',
      'suffix',
      // default: 0
      'maximumFractionDigits',
      'disabled',
      'readonly',
      'outlined',
      'dense'
    ],
    data() {
      return {
        numberStr: this.value != null && !isNaN(this.value) ? this.formatNumber(this.value) : '',
        number: this.value,
        stringRules: [
          // -?: optional negative
          // \d+: integer
          // \d{1,3}(\.\d{3})*: integer with thousand separator
          // (,(\d+)?)?: optional decimal
          v => /^-?(\d+|\d{1,3}(\.\d{3})*)(,(\d+)?)?$/.test(v) || v === '' || 'No es un número válido'
        ].concat(
          this.rules
            ? this.rules.map(
            // Wrap the number based rules.. so they can receive strings from the outside
            // but on the inside they work purely based on numbers
            numberRule => {
              return stringVal => numberRule(this.convertStringToNumber(stringVal))
            }
            )
            : []
        ),
      }
    },
    watch: {
      value: function (value) {
        // Set initial value
        if (!isNaN(value) && value !== null && value !== this.number) {
          this.numberStr = this.formatNumber(value)
          this.number = value
        }
        // Cleanup old value
        if (value == null) {
          this.numberStr = ''
        }
      },
    },
    methods: {
      setNumber(value) {
        this.numberStr = this.replaceDotWithComma(value)
        this.number = this.convertStringToNumber(value)
        this.$emit('input', this.number)
      },
      convertStringToNumber(str) {
        // Return 0 instead of NaN on empty string to make numberRule work on blur on empty input
        if (str !== '') {
          return parseFloat(this.replaceCommaWithDot(str))
        } else {
          // Allow nullable field
          return null
        }
      },
      formatNumber(value) {
        return new Intl.NumberFormat('de-DE', {maximumFractionDigits: this.maximumFractionDigits || 0}).format(value)
      },
      replaceCommaWithDot(value) {
        return value.replace(RegExp(',', 'g'), '.')
      },
      replaceDotWithComma(value) {
        return value.replace(RegExp('\\.', 'g'), ',')
      },
      removeThousandSeparator(value) {
        return value.split('.').join('')
      },
      handleBlur() {
        // Add thousand separator
        if (this.number !== null && !isNaN(this.replaceCommaWithDot(this.numberStr))) {
          this.numberStr = this.formatNumber(this.replaceCommaWithDot(this.numberStr))
          this.number = this.convertStringToNumber(this.removeThousandSeparator(this.numberStr))
          this.$emit('input', this.number)
        }
      },
      handleFocus() {
        this.numberStr = this.removeThousandSeparator(this.numberStr)
      },
    },
  }
</script>

<style scoped>

</style>
